// extracted by mini-css-extract-plugin
module.exports = {"intro":"account-type-add_intro__2CJJZ","title":"account-type-add_title__2zIlT"};